import { useQuery } from "react-query";
import { API_BASE } from "../../../constants/constants";
import { CustodianManagementApi } from "@iliotech/generated-api-v3";
export const useUserCustodians = () => {
  const api = new CustodianManagementApi(undefined, `${API_BASE}/api`);
  return useQuery(`user-custodians`, () => api.getUserCustodians());
};
